/* eslint-disable consistent-return */
import { createValidator } from "revalidate";
import { PASSWORD_POLICY_REGEX } from "app/constants";

export const CREDIT_CARD_ERROR_MAP = {
	cvc: "CVC incorrect",
	holderName: "holderName incorrect",
	month: "Mois incorrect",
	year: "Annee incorrecte",
	expiryYear: "Année expiration incorrecte",
	expiryMonth: "Mois expiration incorrecte",
	number: "Numero de carte incorrecte",
	luhn: "Validation Lhun incorrecte",
};

export const isAmount = createValidator(
	message => value => {
		let valueToValidate = value;
		if (value && typeof value === "string") {
			valueToValidate = value.replace(",", ".");
		}

		if ((valueToValidate && isNaN(valueToValidate)) || valueToValidate < 0) {
			return message;
		}
	},
	"The amount is invalid."
);

export const childrenAge = createValidator(
	message => value => {
		if (value < 0 || value > 18) {
			return message;
		}
	},
	"The child must age between 0 and 18."
);

export const atleastOneUppercase = createValidator(
	message => value => {
		if (!value || !value.length > 0 || !PASSWORD_POLICY_REGEX.UPPERCASE.test(value)) {
			return message;
		}
	},
	"Au moins 1 lettre majuscule"
);

export const atleastOneDigit = createValidator(
	message => value => {
		if (!value || !value.length > 0 || !PASSWORD_POLICY_REGEX.DIGIT.test(value)) {
			return message;
		}
	},
	"Au moins 1 chiffre"
);

export const atleastOneSpecialChar = createValidator(
	message => value => {
		if (!value || !value.length > 0 || !PASSWORD_POLICY_REGEX.SPECIAL_CHAR.test(value)) {
			return message;
		}
	},
	"Au moins 1 caractère spécial"
);
